module.exports = __webpack_public_path__ + "img/contact-linz-2.7f76369.jpg?v=1754999159350";